import '../assets/icons/';
import RtButton from './button/rtButton';
import RtButtonGroup from './button/rtButtonGroup';
import RtView from './layout/rtView';
import RtContainer from './layout/rtContainer';
import RtHeader from './layout/rtHeader';
import RtContent from './layout/rtContent';
import RtFooter from './layout/rtFooter';
import lookup from './lookup';
import RtPicklist from './picklist';
import RtCard from './card/rtCard.vue';
import RtSection from './section/rtSection.vue';
import RtSubSection from './section/rtSubSection.vue';
import RtIcon from './icon/rtIcon';
import RtTag from './tag/rtTag';
import RtForm from './form/rtForm';
import RtFormItem from './form/rtFormItem';
import RtInput from './form/rtInput';
import RtDatePicker from './form/rtDatePicker';
import RtDateRangePicker from './form/rtDateRangePicker';
import RtSwitch from './switch/rtSwitch';
import RtTooltip from './tooltip/rtTooltip';
import RtInputNumber from './inputNumber/rtInputNumber';
import RtInputMoney from './form/rtInputMoney';
import RtUploadVideo from './uploadVideo/rtUploadVideo';
import RtUploadFilelist from './uploadFilelist/rtUploadFilelist';
import RtUploadSlideFilelist from './uploadSlideFilelist/rtUploadSlideFile';
import RtAddress from './address/rtAddress';
import RtKind from './kind/rtKind';
import RtMsgNotice from './msgNotice/rtMsgNotice';
import RtBatchList from './batchList/rtBatchList';
import RtPopover from './popover/rtPopover';
import RtPopconfirm from './popconfirm/rtPopconfirm';

import RtRow from './row/rtRow';
import RtCol from './col/rtCol';
import RtTable from './table/rtTable';
import RtTableColumn from './table/rtTableColumn.js';
import RtTableDropdown from './table/rtTableDropdown';
import RtAdvanceTableGroup from './table/rtAdvanceTableGroup';
import RtAdvanceTableItem from './table/rtAdvanceTableItem';

import RtSearch from './search/rtSearch';
import RtQuery from './search/rtQuery';

import RtTabs from './tabs/tabs.vue';
import RtContentTabs from './tabs/rtContentTabs.js';
import RtTabPane from './tabs/tab-pane.vue';

import RtHeaderButtonGroup from './business/common/rtHeaderButtonGroup';
import RtHeaderIcon from './business/common/rtHeaderIcon';
import RtHeaderTitle from './business/common/rtHeaderTitle';
import RtAttr from './business/common/rtAttr';
import RtVerticalAttr from './business/common/rtVerticalAttr';

import RtDetailHeader from './business/detail/rtDetailHeader';
import RtDetailItem from './business/detail/rtDetailItem';
import RtDetailAside from './business/detail/rtDetailAside';
import RtDetailButton from './business/detail/rtDetailButton';
import RtDetailBottom from './business/detail/rtDetailBottom';

import RtListHeader from './business/list/rtListHeader';
import RtListFilter from './business/list/rtListFilter';
import RtListButtonGroup from './business/list/rtListButtonGroup';

import RtDropDown from './dropdown/rtDropdown.vue';
import RtDropDownMenu from './dropdown/rtDropdownMenu.vue';
import RtDropDownItem from './dropdown/rtDropdownItem.vue';

import RtRadioGroup from './radio/rtRadioGroup.vue';
import RtRadio from './radio/rtRadio.vue';
import RtRadioButton from './radio/rtRadioButton.vue';

import RtCheckboxGroup from './checkbox/rtCheckboxGroup.vue';
import RtCheckbox from './checkbox/rtCheckbox.vue';
import RtCheckboxButton from './checkbox/rtCheckboxButton.vue';

import RtTree from './tree/rtTree.js';
import RtUpload from './upload/rtUpload.js';

import RtLabelGroup from './label/rtLabelGroup.vue';
import RtLabelItem from './label/rtLabelItem.vue';

import RtDefaultImage from './defaultImage/rtDefaultImage.vue';
import RtDialog from './dialog/rtDialog.vue';

import RtCollapseTransition from './collapse/rtCollapseTransition.vue';
import RtCollapse from './collapse/rtCollapse.vue';

import RtAttachment from './attachment/rtAttachment.vue';

import RtApproval from './approval/rtApproval.vue';
import RtApprovalItem from './approval/rtApprovalItem.vue';

import RtCascader from './cascader/rtCascader.vue';

// import RtAddress from './cascader/rtAddress.vue';

import RtListDropdown from './business/list/rtListDropdown';
import RtLink from './link/rtLink';
import RtBadge from './badge/rtBadge';

import RtOriginProgress from './progress/rtOriginProgress.js';
import RtProgress from './progress/rtProgress.vue';
import Message from './message';

import RtFormWrapper from './form/rtFormWrapper';
import RtSteps from './steps/main.vue';
import ElementUI from 'element-ui'; // 按需引入 elementui 组件
import 'element-ui/lib/theme-chalk/index.css';
// elementui 按需引入，多语言设置 https://element.eleme.cn/2.13/#/zh-CN/component/i18n
import ElementLocale from 'element-ui/lib/locale';

// 自定义 plugins
import { plugins } from '../plugins';

// 全部默认配置参数
import xpcConfig from '../config';

import * as ui from '../libs/ui';

if (window.rt) {
  window.rt = Object.assign({}, window.rt, ui);
}

// eslint-disable-next-line prettier/prettier
const components = [
  { name: RtButton.name, component: RtButton },
  { name: RtButtonGroup.name, component: RtButtonGroup },
  { name: RtView.name, component: RtView },
  { name: RtContainer.name, component: RtContainer },
  { name: RtHeader.name, component: RtHeader },
  { name: RtContent.name, component: RtContent },
  { name: RtFooter.name, component: RtFooter },
  { name: lookup.RtLookup.name, component: lookup.RtLookup },
  { name: lookup.RtLookupView.name, component: lookup.RtLookupView },
  { name: lookup.RtCrmLookup.name, component: lookup.RtCrmLookup },
  { name: RtPicklist.name, component: RtPicklist },
  { name: RtCard.name, component: RtCard },
  { name: RtSection.name, component: RtSection },
  { name: RtSubSection.name, component: RtSubSection },
  { name: RtIcon.name, component: RtIcon },
  { name: RtTag.name, component: RtTag },
  { name: RtForm.name, component: RtForm },
  { name: RtFormItem.name, component: RtFormItem },
  { name: RtInput.name, component: RtInput },
  { name: RtDatePicker.name, component: RtDatePicker },
  { name: RtDateRangePicker.name, component: RtDateRangePicker },
  { name: RtSwitch.name, component: RtSwitch },
  { name: RtTooltip.name, component: RtTooltip },
  { name: RtInputNumber.name, component: RtInputNumber },
  { name: RtInputMoney.name, component: RtInputMoney },
  { name: RtUploadVideo.name, component: RtUploadVideo },
  { name: RtUploadFilelist.name, component: RtUploadFilelist },
  { name: RtUploadSlideFilelist.name, component: RtUploadSlideFilelist },
  { name: RtRow.name, component: RtRow },
  { name: RtCol.name, component: RtCol },

  { name: RtTable.name, component: RtTable },
  { name: RtTableColumn.name, component: RtTableColumn },
  { name: RtTableDropdown.name, component: RtTableDropdown },
  { name: RtAdvanceTableGroup.name, component: RtAdvanceTableGroup },
  { name: RtAdvanceTableItem.name, component: RtAdvanceTableItem },

  { name: RtSearch.name, component: RtSearch },
  { name: RtQuery.name, component: RtQuery },

  { name: RtTabs.name, component: RtTabs },
  { name: RtContentTabs.name, component: RtContentTabs },
  { name: RtTabPane.name, component: RtTabPane },

  { name: RtHeaderButtonGroup.name, component: RtHeaderButtonGroup },
  { name: RtHeaderIcon.name, component: RtHeaderIcon },
  { name: RtHeaderTitle.name, component: RtHeaderTitle },
  { name: RtAttr.name, component: RtAttr },
  { name: RtVerticalAttr.name, component: RtVerticalAttr },

  { name: RtDetailHeader.name, component: RtDetailHeader },
  { name: RtDetailItem.name, component: RtDetailItem },
  { name: RtDetailAside.name, component: RtDetailAside },
  { name: RtDetailButton.name, component: RtDetailButton },
  { name: RtDetailBottom.name, component: RtDetailBottom },

  { name: RtListFilter.name, component: RtListFilter },
  { name: RtListHeader.name, component: RtListHeader },
  { name: RtListButtonGroup.name, component: RtListButtonGroup },

  { name: RtDropDown.name, component: RtDropDown },
  { name: RtDropDownMenu.name, component: RtDropDownMenu },
  { name: RtDropDownItem.name, component: RtDropDownItem },

  { name: RtRadioGroup.name, component: RtRadioGroup },
  { name: RtRadio.name, component: RtRadio },
  { name: RtRadioButton.name, component: RtRadioButton },

  { name: RtCheckboxGroup.name, component: RtCheckboxGroup },
  { name: RtCheckbox.name, component: RtCheckbox },
  { name: RtCheckboxButton.name, component: RtCheckboxButton },
  { name: RtTree.name, component: RtTree },
  { name: RtUpload.name, component: RtUpload },

  { name: RtLabelGroup.name, component: RtLabelGroup },
  { name: RtLabelItem.name, component: RtLabelItem },

  { name: RtDefaultImage.name, component: RtDefaultImage },
  { name: RtDialog.name, component: RtDialog },

  { name: RtCollapseTransition.name, component: RtCollapseTransition },
  { name: RtCollapse.name, component: RtCollapse },

  { name: RtAttachment.name, component: RtAttachment },

  { name: RtApproval.name, component: RtApproval },
  { name: RtApprovalItem.name, component: RtApprovalItem },

  { name: RtCascader.name, component: RtCascader },
  { name: RtAddress.name, component: RtAddress },
  { name: RtKind.name, component: RtKind },
  { name: RtMsgNotice.name, component: RtMsgNotice },
  { name: RtBatchList.name, component: RtBatchList },
  { name: RtPopover.name, component: RtPopover },
  { name: RtPopconfirm.name, component: RtPopconfirm },
  { name: RtListDropdown.name, component: RtListDropdown },
  { name: RtLink.name, component: RtLink },
  { name: RtBadge.name, component: RtBadge },
  { name: RtOriginProgress.name, component: RtOriginProgress },
  { name: RtProgress.name, component: RtProgress },
  { name: RtFormWrapper.name, component: RtFormWrapper },
  { name: RtSteps.name, component: RtSteps }
];

const installComponents = (Vue, componentPrefix = 'Rt') => {
  // xpc 组件全局注册
  components.forEach(item => {
    // 组件重命名，防止同名覆盖
    const componentName = item.name.replace('Rt', componentPrefix);
    Vue.component(componentName, item.component);
  });

  Vue.prototype.$message = Message;
};

const installPlugins = (Vue, opts) => {
  // xpc 组件多语言设置
  plugins.forEach(item => Vue.use(item, opts));
};

const install = (Vue, opts) => {
  let { i18n, config } = opts;

  // 合并全局配置参数
  xpcConfig.assign(config);

  // elementui 多语言设置
  if (i18n) {
    Vue.use(ElementUI, {
      i18n: (key, value) => i18n.t(key, value)
    });
  } else {
    Vue.use(ElementUI);
  }
  // 注册 plugins
  installPlugins(Vue, opts);

  // 注册 components
  let { componentPrefix } = xpcConfig.get();
  installComponents(Vue, componentPrefix);
};

export default {
  install,
  getComponents() {
    return components;
  }
};



// WEBPACK FOOTER //
// ./~/vue-xpc/src/components/index.js